import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { TaskGroupEntity, TaskGroupEntityDocument } from "../types";
import { CloseIcon } from "../../../minimals/theme/overrides/CustomIcons";
import { fMonthDayYearDotNotation } from "../../utils/formatTime";
import { fTime } from "../../../minimals/utils/formatTime";
import StickyTable from "../../shared/StickyTable";

export default function GroupEntityDocumentsModal({
  taskGroupEntity,
  handleClose
}: {
  taskGroupEntity: TaskGroupEntity | null;
  handleClose: () => void;
}) {
  const [documents, setDocuments] = useState<TaskGroupEntityDocument[]>([]);
  const momentumUrl = import.meta.env.VITE_MOMENTUM_URL;
  const getAndSetDocuments = async () => {
    const { data } = await axios.get(
      `/api/taskmanagement/taskGroupEntity/GetDocumentsForGroupEntity?id=${taskGroupEntity?.id}`
    );
    setDocuments(data);
  };

  useEffect(() => {
    getAndSetDocuments();
  }, []);

  return (
    <Dialog open onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" width="93%">
          {/* <Stack direction="column">
            <Typography variant="subtitle1">Associated Documents</Typography>
            <Typography variant="body2">{selectedTask?.description}</Typography>
          </Stack> */}
          {/* <Box>
            <IconButton onClick={() => uploadDocument(selectedTask as NewTask)}>
              <Iconify icon="eva:upload-fill" />
            </IconButton>
          </Box> */}
        </Stack>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ paddingBottom: 3 }}>
        <TableContainer component={Card}>
          <StickyTable>
            <TableHead>
              <TableRow>
                <TableCell>Date/Time</TableCell>
                <TableCell>Document</TableCell>
                <TableCell>Uploaded by</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {documents.map((d) => (
                <TableRow sx={{ verticalAlign: "top" }}>
                  <TableCell>
                    <Typography variant="subtitle2">{fMonthDayYearDotNotation(d.uploadedDate)}</Typography>
                    <Typography variant="body2" color={(theme) => theme.palette.grey[600]}>
                      {fTime(d.uploadedDate)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Link
                      sx={{ cursor: "pointer" }}
                      target="_blank"
                      href={`${momentumUrl}opendoc?id=${d.momentumDocumentId}`}
                    >
                      {d.name}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">{d.uploadedBy}</Typography>
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </StickyTable>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} color="inherit">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
